import { render, staticRenderFns } from "./comp_ProductCard-ShadowWithBtn.vue?vue&type=template&id=123f5e3e&scoped=true&"
import script from "./comp_ProductCard-ShadowWithBtn.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCard-ShadowWithBtn.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCard-ShadowWithBtn.vue?vue&type=style&index=0&id=123f5e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f5e3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VHover,VSpacer})
